import React, { Component, cloneElement } from 'react';
import classNames from 'classnames';
import { Link, Button } from 'formlabs-web-components/Link';
import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import Script from 'react-load-script';
import { universalActiveHtml } from '../../utils/index';

const TextPlugin = DisplayComponent(
  class TextPlugin extends Component {
    render() {
      const { body, classes, styleNames, styles, children } = this.props;
      const newBody = body
        ? body
            .replace(/<p><cms-plugin/g, '<cms-plugin')
            .replace(/<\/cms-plugin><\/p>/g, '</cms-plugin>')
        : '';

      const componentsMap = {
        // replace <a> tags by React Router Link component
        // @TODO: this will break links to external domains or fully-qualified URIs
        // https://github.com/ReactTraining/react-router/issues/1147
        a: props =>
          props.className && props.className.includes('button') ? (
            <Button url={props.href}>{props.children}</Button>
          ) : props.href ? (
            <Link {...props} to={props.href} />
          ) : (
            // eslint-disable-next-line jsx-a11y/anchor-has-content
            <a {...props} />
          ),

        // additional components can be embedded in the content and appear as special
        // <cms-plugin> tags, find and replace them with the children components
        'cms-plugin': props =>
          children && children.filter(child => child.key === props.id).pop(),
        script: props => <Script url={props.src} />,
        p: props => {
          // HACK: unpack Header element from paragraph to avoid broken DOM nesting
          if (props.children) {
            const onlyPlugins = props.children.filter(
              child => /\S/.test(child) || typeof child === 'object'
            );

            if (
              onlyPlugins.length === 1 &&
              onlyPlugins[0] &&
              typeof onlyPlugins[0].type === 'function' &&
              onlyPlugins[0].type.name === 'HeaderPlugin'
            ) {
              // keep original paragraph classes
              return cloneElement(onlyPlugins[0], {
                classes: props.className
              });
            }
          }

          return <p {...props} />;
        }
      };

      const nodes = universalActiveHtml(newBody, componentsMap);

      return (
        <div
          className={classNames(classes, 'text-plugin')}
          styleName={classNames(styleNames)}
          style={styles}
        >
          {nodes}
        </div>
      );
    }
  }
);

export default TextPlugin;
